module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel06_770_280_ko-da47fae1a90153b4c9691c74077f4906.jpg";